import type { ApiEnvelope } from "./apiResponse.types";

/** Unwraps the shared API envelope; callers validate the result with their schema. */
export const unwrapApiData = <T>(
  payload: ApiEnvelope<T> | undefined,
): T | undefined =>
  payload && typeof payload === "object" && "data" in payload
    ? (payload as { data: T }).data
    : (payload as T | undefined);
